import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { login } from './AuthThunk';
import { localVariables } from '../../../utils/Constant';
import { authApi } from '../../../Api';
import { AuthState, AuthData } from '../../../Types/Auth';

let roles = [];
// onst storedRoles = localStorage.getItem(localVariables.ROLES);
const storedRoles = JSON.stringify(['user']);

if (storedRoles)
    try {
        roles = JSON.parse(storedRoles);
    } catch (e) {
        console.error('Failed to parse roles from localStorage', e);
    }

const initialState: AuthState = {
    loadingLogin: 'idle',
    access_token: localStorage.getItem(localVariables.ACCESSTOKEN) || null,
    access_token_exp: Number(localStorage.getItem(localVariables.ACCESSTOKEN_EXP)) || null,
    user: {
        email: localStorage.getItem(localVariables.EMAIL) || null,
        type: Number(localStorage.getItem(localVariables.USER_TYPE)) || null,
        roles: roles
    },
    error: null
};

const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        saveAuthData: (state, action: PayloadAction<AuthData>) => {
            const { access_token, access_token_exp, email, roles, type } = action.payload;
            state.access_token = access_token;
            state.access_token_exp = access_token_exp;
            state.user.email = email;
            state.user.roles = roles;
            state.user.type = type;

            state.loadingLogin = 'idle';
            state.error = null;

            authApi.saveAuthData(action.payload);
        },
        clearAuthData: (state) => {
            state.access_token = null;
            state.access_token_exp = null;
            state.user.email = null;
            state.user.type = null;
            state.loadingLogin = 'idle';
            state.error = null;

            authApi.clearAuthData();
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(login.pending, (state) => {
                state.loadingLogin = 'loading';
                state.error = null;
            })
            .addCase(login.rejected, (state, action) => {
                state.loadingLogin = 'failed';
                state.error = action.payload?.message || 'Login failed';
            })
            .addCase(login.fulfilled, (state, action) => {
                const { access_token, email, roles, type } = action.payload;
                const expiration = new Date();
                expiration.setHours(expiration.getHours() + 1);
                const expirationTimestamp = Math.floor(expiration.getTime() / 1000);

                state.access_token = access_token;
                state.access_token_exp = expirationTimestamp;
                state.user.email = email;
                state.user.roles = roles;
                state.user.type = type;
                state.loadingLogin = 'idle';
                state.error = null;

                authApi.saveAuthData({ ...action.payload, access_token_exp: expirationTimestamp });
            });
    }
});

export const { saveAuthData, clearAuthData } = authSlice.actions;
export default authSlice.reducer;
